import React, { useEffect } from 'react'
import useDispatchCommentState, {
  CommentDataProps,
} from '../../stores/DispatchCommentState'
import { useState, Downgraded, State } from '@hookstate/core'
import { DisplayComments } from '~/components/DisplayComments'

const defaultCommentsState: readonly CommentDataProps[] = []

interface DispatchDisplayCommentsProps {
  readonly dispatchId: number | null
  readonly commentIsCompressed: State<boolean>
  readonly readonly: boolean
  readonly moveScrolltoComment?: boolean
  readonly ocurrenceId?: number | string | null
  readonly code?: string
  readonly dispatchViewMode?: boolean
}

export function DispatchDisplayComments({
  dispatchId,
  commentIsCompressed,
  readonly = false,
  moveScrolltoComment,
  ocurrenceId,
  code,
  dispatchViewMode = false
}: DispatchDisplayCommentsProps) {
  const [syncSuccess, setSyncSuccess] = React.useState(true)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [syncError, setSyncError] = React.useState<string | null>(null)

  const {
    allCurrentComments,
    allCurrentCommentsDispatchViewMode,
    sortComment,
    syncPreviousComments,
    setDefaultComments
  } = useDispatchCommentState()
  const loading = useState(true)
  const commentList = useState(defaultCommentsState)
  const allCommentsValue = dispatchViewMode ? allCurrentCommentsDispatchViewMode().attach(Downgraded).value : allCurrentComments().attach(Downgraded).value

  const populateComments = () => {
    if(!allCommentsValue) return;
    commentList.set(
      allCommentsValue
        ? allCommentsValue.map((element) => element).sort(sortComment)
        : []
    )
  }

  const getCommentsFromDispatchId = async () => {
    commentList.set(defaultCommentsState)
    setSyncSuccess(true)
    setSyncError(null)

    try {
      const success = await syncPreviousComments(dispatchId, 'DESC', dispatchViewMode)

      if (!success) {
        setSyncSuccess(false)
        setSyncError('Erro ao sincronizar comentários.')
      } else if (
        commentList.get().length &&
        commentList[0].occurrenceId.get() &&
        ocurrenceId != commentList[0].occurrenceId.get()
      ) {
        setSyncSuccess(false)
        setSyncError('Erro ao sincronizar comentários relacionados a ocorrência.')
      }
    } catch (error) {
      console.error('Erro ao buscar comentários:', error)
      setSyncSuccess(false)
      setSyncError(error instanceof Error ? error.message : 'Erro desconhecido')
    }
  }

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      loading.set(true)
      await getCommentsFromDispatchId()
      if (isMounted) {
        loading.set(false)
      }
    }

    fetchData()

    return () => {
      isMounted = false
      setDefaultComments(dispatchViewMode)
    }
  }, [ocurrenceId])

  useEffect(() => {
    populateComments()
  }, [allCommentsValue])

  return (
    <DisplayComments
      isEdit={true}
      isDispatch={true}
      comments={commentList}
      commentIsCompressed={commentIsCompressed}
      readonly={readonly}
      moveScrolltoComment={moveScrolltoComment}
      loading={loading.get()}
      dispatchCode={code ? code : ''}
      refresh={syncSuccess}
      refreshAction={getCommentsFromDispatchId}
    />
  )
}
